module.exports = {

   // General
   "refresh": 'Refresh',
   "app.title": 'Dashboard',
   "fetch.error": 'Could not load data. ({message})',
   "submit.error": 'Could not save data. ({message})',
   "filter.fetch.error": 'Could not load filter options. ({message})',
   "save.label": 'Save',
   'save.error': 'The changes could not be saved. ({message})',
   "cancel.button": 'Cancel',
   "close.button": 'Close',
   "ok.button": 'OK',
   'delete.button': 'Delete',
   'path.logout': 'Log Out',
   'leavePage': "You have made changes, which have not been saved. Do you want to discard changes?",
   'deletion.error': '"{name}" could not be deleted. ({message})',
   'delete.title': 'Delete',
   'noPermission.message': "You do not have permission to view this page. Contact your administrator to get permission.",
   'next.button': 'Next',
   'previous.button': 'Previous',
   'version': '{version}',

   //Sign in card
   'signIn.button.': "Sign In With Microsoft",
   'signIn.label': 'Sign In',

   'user.notOperatorAdmin.error': "User is not an operator admin. You are logged in as, {email}. Log in with a different account or contact your administrator to get permission.",
   'operator.notOperatorActive.error': "Operator is not active. Contact your administrator to get permission.",

   //App bar
   'application.title': 'Pressure Test Logger',
   'super.title': 'Super Admin Console',
   'operator.appbar.title': 'Admin Console {operator}',
   'appbar.title': '{appTitle} - {subTitle}',
   'search.placeholder': "Search…",

   //Operators
   'operators.title': 'Operators',
   'operators.button.label': 'Operators',
   'operators.newButton.label': 'New Operator',
   'operators.name.column': 'Name',
   'operators.email.column': 'Email',
   'operators.lastTest.column': 'Last Test',
   'operators.lastLogin.column': 'Last Login',
   'operators.active.column': 'Active',

   //Bug Reports
   'bugReports.button.label': 'Bug Reports',
   'bugReports.title': 'Bug Reports',
   'bugReports.reporter.column': 'Reporter',
   'bugReports.operator.column': 'Operator',
   'bugReports.description.column': 'Description',
   'bugReports.status.column': 'Status',
   'bugReports.submitted.column': 'Submitted',
   'bugReports.delete.button': 'Delete',
   'bugReports.delete.title': 'Delete Bug Report',
   'bugReports.delete.message': 'This will remove the report from the list. This cannot be undone.',
   'bugReportDetail.title': 'Bug Report',
   'bugReportDetail.status.label': 'Status',
   'bugReportDetail.comments.label': 'Comments',
   'bugReportDetail.noComments': 'No messages yet.',
   'bugReportDetail.reply.button': 'Send',

   //FAQ
   'faq.button.label': 'FAQ',
   'faq.title': 'FAQ',
   'faq.order.column': 'Order',
   'faq.question.column': 'Question',
   'faq.answer.column': 'Answer',
   'faq.add.button': 'Add',
   'faq.edit.button': 'Edit',
   'faq.delete.button': 'Delete',
   'faq.delete.title': 'Delete FAQ',
   'faq.delete.message': 'This will remove the FAQ entry. This cannot be undone.',
   'faq.edit.title': 'Edit FAQ',
   'faq.answer.markdownHint': 'Markdown supported:  **bold**  *italic*  - list  1. numbered  [link](https://…)  # heading',
   'faq.answer.previewLabel': 'Preview',
   'extraField.title': 'Extra Fields',
   'extraField.order.column': 'Order',
   'extraField.label.column': 'Label',
   'extraField.type.column': 'Type',
   'extraField.required.column': 'Required',
   'extraField.details.column': 'Options',
   'extraField.add.button': 'Add',
   'extraField.edit.button': 'Edit',
   'extraField.delete.button': 'Delete',
   'extraField.moveUp.button': 'Move Up',
   'extraField.moveDown.button': 'Move Down',
   'extraField.delete.title': 'Delete Extra Field',
   'extraField.delete.message': 'This removes the field from the app for new tests. Values already saved on tests stay in their reports.',
   'extraField.edit.title': 'Edit Extra Field',
   'extraField.type.number': 'Number',
   'extraField.type.text': 'Text',
   'extraField.type.dropdown': 'Dropdown',
   'extraField.type.yesno': 'Yes / No',
   'extraField.isRequired.label': 'Required',
   'extraField.allowExplanation.label': 'Show an explanation text field',
   'extraField.options.label': 'Dropdown options',
   'extraField.options.add': 'Add option',
   'extraField.options.required': 'Add at least one option',
   'extraField.options.unique': 'Options must be unique',

   'operator.title': 'Operator',
   'operator.new.title': 'New Operator',
   'operator.noOperator.title': 'No Operator Available',
   'operator.openOperatorAdmin.title': 'Open Operator Admin',
   'operator.deleteOperator.button': 'Delete Operator',
   'operator.cancelDeletion.button': 'Cancel Deletion',
   'operator.delete.title': 'Delete Operator "{name}"',
   'operator.delete.message': 'This schedules "{name}" for PERMANENT deletion in 3 days, along with all of its data - users, zones, segments, tests, readings, test types, pressure specs, pipe diameters, equalization times, calibration settings, and gauge calibrations. You can cancel the deletion any time before then. Type the operator name below to confirm.',
   'operator.delete.confirmField.label': 'Operator name',
   'operator.pendingDeletion.banner.message': 'This operator is scheduled for permanent deletion on {date} ({days, plural, one {# day} other {# days}} from now).',
   'pendingDeletion.banner.cancelButton': 'Cancel Deletion',
   'operator.pendingDeletion.listIndicator': '(Pending deletion)',
   'operator.duplicateOperator.button': 'Duplicate Operator',
   'operator.duplicate.title': 'Duplicate "{name}"',
   'operator.duplicate.message': 'This will open the Create Operator form pre-filled with a copy of "{name}"\'s settings. Nothing is saved until you finish the form and click Create.',
   'operator.duplicate.submit.button': 'Continue',
   'operator.name.label': 'Name:',
   'operator.email.label': 'Email:',
   'operator.minimumAllowablePressure.label': 'Minimum Allowable Pressure (psi):',
   'operator.defaultStabilizationPeriod.label': 'Default Stabilization Period (minutes):',
   'operator.autoDeleteDays.label': 'Auto-Delete After Days:',
   'operator.gpsTimeout.label': 'GPS Timeout:',
   'operator.privacyPolicy.label': 'Privacy Policy / Terms of Use:',
   'operator.certifyText.label': 'Certification Text:',
   'operator.sendFailedTests.label': 'Send to FTP Failed Tests',
   'operator.sendEmail.label': 'Send Email',
   'operator.prohibitLowBatTest.label': 'Prohibit Low Battery Test',
   'operator.emailRecipient.label': 'Email Recipient',
   'operator.emailType.label': 'Email Type',
   'operator.maximumAllowablePressure.label': 'Maximum Allowable Pressure (psi):',
   'operator.maximumAllowablePressureDrop.label': 'Maximum Pressure Drop (psi):',
   'operator.active.label': 'Active',
   'operator.calibrationValidityPeriod.label': 'Calibration Validity Period (days)',
   'operator.calibrationWarningPeriod.label': 'Calibration Warning Period (days)',
   'operator.noOperator.label': 'No Operator Selected',
   'operator.testLength.label': 'Test Durations',
   'operator.testLengthEdit.title': 'Edit Test Duration',
   'operator.minimumPipeDiameter.column': 'Max. Pipe Diameter',
   'operator.minimumPipeLength.column': 'Min. Footage',
   'operator.testLength.column': 'Test Duration',
   'operator.testType.column': 'Test Type',
   'operator.addTestLength.button': 'Add',
   'operator.editTestLength.button': 'Edit',
   'operator.deleteTestLength.button': 'Delete',
   'operator.FieldLabel01.label': 'Field Name 1',
   'operator.FieldLabel02.label': 'Field Name 2',
   'operator.FieldLabel03.label': 'Field Name 3',
   'operator.FieldLabel04.label': 'Field Name 4',
   'operator.FieldLabel05.label': 'Field Name 5',
   'operator.FieldLabel06.label': 'Field Name 6',
   'operator.FieldLabel07.label': 'Field Name 7',
   'operator.FieldLabel08.label': 'Field Name 8',
   'operator.singleSegmentOnly.label' : 'Single Segment Only',
   'operator.testEntireLog.label' : 'Analyze Entire Dataset',
   'operator.logBeforeTestDuration.label' : 'Log before Test Duration',
   'operator.testRoundPressureValues.label' : 'Round Pressure Values',
   'operator.addOriginalPressureToReport.label' : 'Add Original PSI in report',
   'operator.tesType.column' : 'Test Type',
   'operator.systemPressure.column': 'System Pressures',
   'operator.testType.label': 'Test Types',
   'operator.addTestType.button': 'Add',
   'operator.editTestType.button': 'Edit',
   'operator.deleteTestType.button': 'Delete',
   'operator.testTypeEdit.title' : 'Test Type',
   'operator.systemPressureEdit.title' : 'System Pressure',
   'operator.systemPressures.label' :  'System Pressures',
   'operator.testSystemPressure.column': 'System Pressure',
   'operator.pressureSpecs.label': 'Pressure Specs',
   'operator.pipeDiameter.label': 'Pipe Diameters',
   'operator.pipeDiameterEdit.title': 'Edit Pipe Diameter',
   'operator.addPipeDiameter.button': 'Add',
   'operator.editPipeDiameter.button': 'Edit',
   'operator.deletePipeDiameter.button': 'Delete',
   'operator.multipleSegmentPipe.label': 'Multiple Segment Pipe',
   'operator.uploadPhotos.label': 'Upload Photos',
   'operator.temperatureCompensation.label': 'Temperature Compensation',
   'operator.equalizationTimeCalculation.label': 'Equalization Time Calculation',
   'operator.showFaqs.label': 'Show FAQs',
   'operator.showBugReports.label': 'Show Bug Reports',
   'operator.equalizationTime.label': 'Equalization Times',
   'operator.equalizationTimeEdit.title': 'Edit Equalization Time',
   'operator.addEqualizationTime.button': 'Add',
   'operator.editEqualizationTime.button': 'Edit',
   'operator.deleteEqualizationTime.button': 'Delete',
   // Users
   'users.title': "Users",
   'users.addUser.button': "Add User",
   'users.addMultiple.button': "Add Multiple Users",

   'user.name.label': "Name:",
   'user.email.label': "Email:",
   'user.operatorAdmin.label': "Operator Admin",
   'user.active.label': "Active",
   'user.emailList.label': 'Email List:',
   'user.multipleUsers.title': 'Add Multiple Users',
   'user.multipleUsers.subtitle': 'Enter email addresses separated by commas',
   'user.newUser.title': 'New User',
   'user.user.title': 'User',
   'user.noUser.title': 'No User Selected',
   'user.invalidUser.title': 'Invalid User',
   'user.active.users' : 'Active users'
};
